import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
// @mui
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs/CustomBreadcrumbs';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useModal } from '@/hooks/useModal';
import { useRole } from '@/hooks/useRole';
import { PATH_DASHBOARD } from '@/routes/paths';
import { createCanceledProducts } from '@/services/canceled-products';
import { translates } from '@/utils';
import { TITLE } from '@/utils/constants';
import { errorOrders } from '@/utils/errors';
import { Roles } from '@/utils/roles';
import { Button, Container } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { changeOrderService, getOrdersByIdService } from '../../../services';
import { CanceledProducts } from '../components/modals/canceledProducts';
import { OrderNewEditForm } from '../form';
import { useFetch } from '../hooks/useFetch';

export default function ProductEditPage() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { authorized } = useRole([Roles.ADMIN, Roles.ATM]);
  const [isGrid, setIsGrid] = useLocalStorage({ key: `${TITLE}/use-grid`, defaultValue: false });
  const { id } = useParams();

  const { fetchValues } = useFetch({ fetchFunction: createCanceledProducts });
  const handleCanceledProducts = async (productId: any) => {
    try {
      await fetchValues(productId);
    } catch (error) {
      console.log('🚀 ~ file: edit.tsx:39 ~ handleCanceledProducts ~ error:', error);
    }
  };

  const { fetchProperties, isLoading } = useFetch({ fetchFunction: changeOrderService });

  const handleChangeOrder = async (values: any, logFormat: any) => {
    try {
      await fetchProperties(id ?? '', values);
      if (deleteOrdersDetails) {
        await handleCanceledProducts(logFormat);
      }
      navigate(PATH_DASHBOARD.orders.view(id as string));
    } catch (error) {
      console.log('🚀 ~ file: edit.tsx:50 ~ handleChangeOrder ~ error:', error);
      const errorMessage = errorOrders[error?.error] ?? 'Problemas Añadiendo Productos';

      enqueueSnackbar(errorMessage.label, { variant: 'error' });
    }
  };

  const { data, fetchId: fetchOrderById } = useFetch({
    fetchFunction: getOrdersByIdService,
    getData: true,
  });
  const handleGetOrderById = async () => {
    try {
      await fetchOrderById(id ?? '');
    } catch (error) {}
  };

  const { handleChange, open } = useModal();
  const [deleteOrdersDetails, setDeleteOrdersDetails] = useState<any>();
  const handleSubmit = async (dataForm: any, checked?: boolean) => {
    try {
      if (!authorized) {
        enqueueSnackbar('No cuentas con los permisos suficientes', {
          variant: 'warning',
          autoHideDuration: 2000,
        });
        return;
      }
      if (checked !== undefined) {
        const { items, ...rest } = checked ? deleteOrdersDetails : dataForm;

        const ordersDetails: any = items.map((item: any) => {
          if (item.quantity + item.discountNumber < 1) {
            throw null;
          }
          return {
            id: item.id,
            // productId: Number(item.product.value),
            quantity: Number(item.quantity),
            ...(item.description && { description: item.description }),
            discount: Number(item.discount || 0),
            quantity_discount: Number(
              item.discountNumber > 0 && item.discount > 0 ? item.discountNumber : 0
            ),
          };
        });

        const valuesFormatted = {
          table: rest.table,
          vendor: rest.vendor.id,
          ordersDetails,
        };
        setDeleteOrdersDetails(dataForm);

        await handleChangeOrder(valuesFormatted, dataForm);
      } else {
        setDeleteOrdersDetails({ ...dataForm, vendor: data?.vendor, orderId: data?.id });
        handleChange();
      }
    } catch (error) {
      /* empty */
    }
  };

  useEffect(() => {
    handleGetOrderById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title> {TITLE}: Edit Order</title>
      </Helmet>

      <Container maxWidth={false}>
        <CustomBreadcrumbs
          links={[
            { name: translates.dashboard, href: PATH_DASHBOARD.root },
            {
              name: translates.order,
              href: PATH_DASHBOARD.orders.root,
            },
            {
              name: translates.detail,
              href: PATH_DASHBOARD.orders.view(id ?? ''),
            },
            { name: data?.table ?? data?.id },
          ]}
          action={
            [
              // <Button
              //   variant="outlined"
              //   sx={{ width: { sm: 'auto', xs: '90vw' } }}
              //   color="info"
              //   onClick={() => setIsGrid((prev) => !prev)}
              // >
              //   {!isGrid ? [translates.gridMood] : [translates.listMood]}
              // </Button>,
            ]
          }
        />

        <OrderNewEditForm
          isGrid={isGrid}
          isLoading={isLoading}
          onSave={handleSubmit}
          isEdit
          currentProduct={data}
        />
      </Container>

      <CanceledProducts
        invoices={deleteOrdersDetails}
        ordersDetailsActual={data?.ordersDetails}
        onClose={handleChange}
        open={open}
        onSave={handleSubmit}
      />
    </>
  );
}
